/* eslint-disable no-fallthrough */
import { vendorRatingActionTypes } from '../../actions/configurations/vendorRatingActions';

const VendorRatingReducers = (state = {}, action) => {
  switch (action.type) {
  case vendorRatingActionTypes.GET_VENDOR_RATING_CONFIG.LOADING: {
    const { getVendorRatingLoading } = action;
    return {
      ...state,
      getVendorRatingLoading,
    };
  }

  case vendorRatingActionTypes.GET_VENDOR_RATING_CONFIG.SUCCESS: {
    const { getVendorRatingSuccess } = action;
    return {
      ...state,
      getVendorRatingSuccess,
    };
  }

  case vendorRatingActionTypes.UPDATE_VENDOR_RATING_CONFIG.LOADING: {
    const { updateVendorRatingSettingLoading } = action;
    return {
      ...state,
      updateVendorRatingSettingLoading,
    };
  }

  case vendorRatingActionTypes.CREATE_VENDOR_RATING.LOADING: {
    const { createSellerRatingLoading } = action;
    return {
      ...state,
      createSellerRatingLoading,
    };
  }

  case vendorRatingActionTypes.UPDATE_VENDOR_RATING.LOADING: {
    const { updateVendorRatingLoading } = action;
    return {
      ...state,
      updateVendorRatingLoading,
    };
  }

  case vendorRatingActionTypes.ENABLE_VENDOR_RATING_CONFIG.LOADING: {
    const { enableVendorRatingConfigLoading } = action;
    return {
      ...state,
      enableVendorRatingConfigLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default VendorRatingReducers;
